import React from "react";
import PropTypes from "prop-types";
import {getGradientValue} from "lib/gradient";

/**
 * Количество записанных игроков (players_count) может не совпадать с количеством игроков
 * в массиве players, так как по условию для неавторизованных пользователей мы должны
 * показывать только первых 4-х игроков в карточке игры
 *
 * @param {number} players_count
 * @param {number} max_players
 * @param {boolean} is_past
 * @param {boolean} is_training
 * @param {boolean} is_report_sent
 * @return {object}
 */
const PlayersRange = ({ players_count, max_players, is_past , is_training, is_report_sent}) => {
    let size = Math.floor((players_count / max_players) * 100);
    let mainCastSize = players_count;
    const reserveSize = players_count - max_players;

    if (size >= 100) {
        size = 100;
        mainCastSize = max_players;
    }

    let backgroundColor = "#" + getGradientValue("FFC947", "C66900", size);

    const actionLabel = (() => {
        if (is_report_sent) {
            return 'Пришли';
        }

        if (is_training) {
            return is_past ? 'Тренировались' : 'Тренируются';
        }

        return is_past ? 'Играли' : 'Играют';
    })();


    return (
        <div className="players-range">
            <div className="players-range__progress-bar">
                <div
                    className="players-range__filler"
                    style={{
                        backgroundColor,
                        width: `${size}%`,
                        maxWidth: `${size}%`,
                    }}
                />
            </div>
            <div className="players-range__item">
                <div className="fs-caption">{actionLabel}</div>
                <div>{`${mainCastSize}/${max_players}`}</div>
            </div>
            {reserveSize > 0 && !is_past && (
                <div className="players-range__item">
                    <div className="fs-caption">В резерве:</div>
                    <div>{reserveSize}</div>
                </div>
            )}
        </div>
    );
};

PlayersRange.defaultProps = {
    players_count: 0,
};

PlayersRange.propTypes = {
    players_count: PropTypes.number.isRequired,
    max_players: PropTypes.number.isRequired,
    is_past: PropTypes.bool.isRequired,
    is_report_sent: PropTypes.bool.isRequired,
    is_training: PropTypes.bool.isRequired,
};

export default PlayersRange;
